import { SCORING_EXPLAIN_FAQ } from './scoring';

export type FaqEntry = { q: string; a: string };

export const faq: FaqEntry[] = [
  {
    q: 'Is this another LeetCode clone?',
    a: 'No. LeetCode rewards finding the right answer fast. Prepzio rewards how you think: your hint usage, your reasoning, and how clearly you can explain a solution. A junior who can explain a working for-loop is more hireable than one who memorised quicksort.',
  },
  {
    q: 'Will the AI just give me answers?',
    a: 'It is built not to. Prepzio uses a hint ladder: direction first, then a smaller sub-problem, then a related mini example. You can always ask to see the solution, but doing so is friction-full and lowers your Independence Score over time.',
  },
  {
    q: 'How do Prepzio scores work?',
    a: SCORING_EXPLAIN_FAQ,
  },
  {
    q: 'Will I have to pay?',
    a: 'Private beta is free. We will introduce small plans once core practice loops are validated. Everyone on the waitlist gets founder pricing and an invite before launch.',
  },
  {
    q: 'When can I actually use it?',
    a: 'Private beta opens summer 2026. Waitlist members are invited in batches, in the order you joined. We are not chasing a public launch; we are chasing a product that genuinely moves the needle for the first cohort.',
  },
  {
    q: 'How is my data used?',
    a: 'Your email is used only for waitlist and beta invites. No tracking ads, no resale. Inside the app we log practice answers and hint usage to compute your scores. You can request deletion at any time. Details on the Privacy page.',
  },
];
